import { Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { LearnerResourcesService } from "src/app/_services/learner-resources.service";
import { GetLearnerResources, GetLearnerResourcesError, GetLearnerResourcesSuccess, GetModuleTypesOfResources, GetModuleTypesOfResourcesError, GetModuleTypesOfResourcesSuccess, UpdateLearnerResources, UpdateLearnerResourcesError, UpdateLearnerResourcesSuccess } from "./learner-resources.actions";
import { catchError, map, switchMap } from "rxjs/operators";
import { HttpErrorResponse } from "@angular/common/http";
import { of } from "rxjs";
import { LearnerResourcesDto } from "src/app/_models/LearnerResources";

@Injectable()
export class LearnerResourcesEffects {
  constructor(
    private actions$: Actions,
    private learnerResourcesService: LearnerResourcesService
  ) {}

  public getModuleTypesOfResourcesEffects$ = createEffect(() =>
    this.actions$.pipe(
      ofType(GetModuleTypesOfResources),
      switchMap((payload) =>
        this.learnerResourcesService.getModuleTypesOfResources$(payload.courseId).pipe(
          map((result: string[]) => {
            return GetModuleTypesOfResourcesSuccess({ result: result });
          }),
          catchError((error: HttpErrorResponse) => {
            return of(GetModuleTypesOfResourcesError({error: error}));
          }),
        )
      )
    )
  );

  public getLearnerResourcesEffects$ = createEffect(() => 
    this.actions$.pipe(
      ofType(GetLearnerResources),
      switchMap((payload) => 
        this.learnerResourcesService.getLearnerResources$(
            payload.courseId, payload.langCode, payload.isInitialLoad)
        .pipe(
          map((result: LearnerResourcesDto[]) => {
            return GetLearnerResourcesSuccess({result: result})
          }),
          catchError((error: HttpErrorResponse) => {
            return of(GetLearnerResourcesError({error: error}));
          }),
        )
      )
    )
  );

  public updateLearnerResourcesEffect$ = createEffect(() => 
    this.actions$.pipe(
      ofType(UpdateLearnerResources),
      switchMap((payload) => 
        this.learnerResourcesService.updateLearnerResources$(
          payload.updateFilter,
        )
        .pipe(
          map((result: boolean) => {
            return UpdateLearnerResourcesSuccess({result: result});
          }),
          catchError((error: HttpErrorResponse) => {
            return of(UpdateLearnerResourcesError({error: error}));
          }),
        )
      )
    )
  );
}